module.exports = __webpack_public_path__ + "img/photo1.d947660a.jpg";